import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ProductMiniModule } from '@features/product-mini/product-mini.module';
import { SharedModule } from '@shared/shared.module';

import { SearchContainerComponent } from './search-container/search-container/search-container.component';
import { SearchContentResultsComponent } from './search-content-results/search-content-results.component';
import { SearchInputComponent } from './search-input/search-input.component';
import { GetByContentTypePipe } from './search-pipes/get-by-content-type.pipe';
import { GetQueryParamForLinkPipe } from './search-pipes/get-query-param-for-link.pipe';
import { ShowSearchContentPipe } from './search-pipes/show-search-content.pipe';
import { HighlightPipe } from './search-pipes/highlight.pipe';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        ProductMiniModule,
        RouterModule,
        SearchInputComponent,
        SearchContainerComponent,
        GetByContentTypePipe,
        ShowSearchContentPipe,
        SearchContentResultsComponent,
        GetQueryParamForLinkPipe,
        HighlightPipe
    ],
    exports: [SearchContainerComponent, GetByContentTypePipe]
})
export class SearchModule {}
